import { Route, Routes } from 'react-router-dom';

import { TabsPagesLayout } from '~settings/components';
import { ModalContextProvider } from '~settings/components/Modal';

import { CreateLabelGroupPage } from './pages/CreateLabelGroupPage';
import { DetailLabelGroupPage } from './pages/DetailLabelGroupPage';
import { EditLabelGroupPage } from './pages/EditLabelGroupPage';
import { ListLabelGroupPage } from './pages/ListLabelGroupPage';

export function LabelGroupRouter() {
  return (
    <Routes>
      <Route path=":labelGroupId" element={<DetailLabelGroupPage />} />
      <Route path=":labelGroupId/edit" element={<EditLabelGroupPage />} />
      <Route path="/create" element={<CreateLabelGroupPage />} />
      <Route element={<TabsPagesLayout />}>
        <Route
          path="*"
          element={
            <ModalContextProvider>
              <ListLabelGroupPage />
            </ModalContextProvider>
          }
        />
      </Route>
    </Routes>
  );
}
LabelGroupRouter.displayName = 'LabelGroupRouter';
